import DatiClinicoStrumentaliIctusEdit from "./components/DatiClinicoStrumentaliIctusEdit.vue";
import DatiClinicoStrumentaliIctusView from "./components/DatiClinicoStrumentaliIctusView.vue";
import DatiClinicoStrumentaliIctusList from "./components/DatiClinicoStrumentaliIctusList.vue";

export default {
    DatiClinicoStrumentaliIctusEdit,
    DatiClinicoStrumentaliIctusView,
    DatiClinicoStrumentaliIctusList,
};
